// The layout rows on step 4 of the mock request form: "Section A — 40 ×
// Multiple choice". A third module beside mock_request_wizard.js rather than
// a third behaviour inside it — that file's header says it owns exactly two
// (the step, the lane), and this one owns exactly one: the rows.
//
// NOT IN packs/, for the reason mock_composer.js records — every file under
// that directory becomes its own webpack entrypoint and emits a bundle no
// layout loads. Imported by packs/application.js.
//
// HIDES, NEVER DISABLES, the wizard module's contract. Every row on the page
// posts whether or not it is on screen; Mocks::RequestedSections drops the
// blank ones, and the controller ignores all of them when "Let the expert
// decide the mix" is ticked. So with the pack absent the two spare rows the
// server renders are how a student lays out a three-section paper, and the
// Add and Remove buttons — which do nothing without this file — arrive
// `hidden` and are revealed here, exactly as the step buttons are.
//
// Five things it does, and nothing that decides anything:
//   - clones a row from the <template>, renumbering the posted index and the
//     section letter, so a fourth section posts as [3] and reads "Section D";
//   - removes a row, and reletters the ones after it;
//   - sums the counts into "N questions in all" and mirrors that into the
//     Questions box, which it locks while the rows CARRY A TOTAL — the server
//     prefers the rows anyway; this only keeps the two from disagreeing on
//     screen. Blank rows leave the box unlocked and holding its own figure,
//     because blank rows are what the server reads as "that many, any kind";
//     locking it on a stale mirror would submit a number the student could
//     neither see as theirs nor change;
//   - hides the rows when the mix is left to the expert, which is the other
//     way of leaving the box in charge;
//   - swaps the blurb and the self-marked badge under a row when its family
//     changes, reading both off the chosen <option>'s own data attributes so
//     there is no second copy of MockItem::Type::FAMILIES here.

function setup() {
  const root = document.querySelector("[data-requested-sections]");
  if (root === null) return;

  const rowsBox = root.querySelector("[data-requested-section-rows]");
  const template = root.querySelector("template[data-requested-section-template]");
  const addButton = root.querySelector("[data-requested-section-add]");
  const total = root.querySelector("[data-requested-total]");
  const leaveBox = root.querySelector('input[name="mock_request[leave_mix_to_expert]"]');
  const countField = document.querySelector("[data-requested-total-field]");
  if (rowsBox === null || template === null) return;

  const rows = () => Array.from(rowsBox.querySelectorAll("[data-requested-section]"));
  const letter = (index) => String.fromCharCode("A".charCodeAt(0) + index);

  // --- one row ---------------------------------------------------------------

  const syncNote = (row) => {
    const select = row.querySelector("[data-requested-section-family]");
    const note = row.querySelector("[data-requested-section-note]");
    const blurb = row.querySelector("[data-requested-section-blurb]");
    const held = row.querySelector("[data-requested-section-held]");
    const option = select.selectedOptions[0];
    const chosen = option !== undefined && option.value !== "";

    note.hidden = !chosen;
    blurb.textContent = chosen ? option.dataset.blurb || "" : "";
    held.hidden = !(chosen && option.dataset.held === "true");
  };

  const renumber = () => {
    rows().forEach((row, index) => {
      row.querySelector("[data-requested-section-letter]").textContent = `Section ${letter(index)}`;
      row.querySelectorAll("[name]").forEach((field) => {
        field.name = field.name.replace(/\[requested_sections\]\[[^\]]*\]/, `[requested_sections][${index}]`);
      });
      row.querySelectorAll("[aria-label]").forEach((field) => {
        field.setAttribute("aria-label", field.getAttribute("aria-label").replace(/Section [A-Z_]+/, `Section ${letter(index)}`));
      });
    });
  };

  const sum = () => {
    const n = rows().reduce((acc, row) => {
      const count = Number(row.querySelector("[data-requested-section-count]").value);
      return acc + (Number.isFinite(count) && count > 0 ? count : 0);
    }, 0);
    if (total) {
      total.textContent = `${n} ${n === 1 ? "question" : "questions"} in all`;
      total.hidden = n === 0;
    }
    const leaving = leaveBox !== null && leaveBox.checked;
    const inUse = !leaving && n > 0;
    if (countField) {
      countField.readOnly = inUse;
      if (inUse) countField.value = n;
    }
  };

  const wire = (row) => {
    row.querySelector("[data-requested-section-family]").addEventListener("change", () => { syncNote(row); });
    row.querySelector("[data-requested-section-count]").addEventListener("input", sum);

    const remove = row.querySelector("[data-requested-section-remove]");
    remove.hidden = false;
    remove.addEventListener("click", () => {
      // The first row is the layout; removing it is what the checkbox below
      // is for. Clearing it instead keeps the form honest about what posts.
      if (rows().length === 1) {
        row.querySelector("[data-requested-section-count]").value = "";
        row.querySelector("[data-requested-section-family]").value = "";
        syncNote(row);
      } else {
        row.remove();
      }
      renumber();
      sum();
    });
    syncNote(row);
  };

  // --- adding ----------------------------------------------------------------

  const add = () => {
    const fragment = template.content.cloneNode(true);
    const row = fragment.querySelector("[data-requested-section]");
    const index = rows().length;
    row.querySelectorAll("[name]").forEach((field) => {
      field.name = field.name.replace("__i__", String(index));
    });
    rowsBox.insertBefore(fragment, addButton.parentElement);
    wire(row);
    renumber();
    row.querySelector("[data-requested-section-count]").focus();
  };

  if (addButton) {
    addButton.hidden = false;
    addButton.addEventListener("click", add);
  }

  // The two spare rows the server renders for the no-JavaScript case are
  // noise once Add exists: drop the ones nobody typed into.
  rows().forEach((row) => {
    const blank = row.querySelector("[data-requested-section-count]").value === "" &&
                  row.querySelector("[data-requested-section-family]").value === "";
    if (blank && rows().length > 1) row.remove();
  });
  rows().forEach(wire);
  renumber();

  // --- leaving it to the expert ------------------------------------------------

  const syncLeave = () => {
    rowsBox.hidden = leaveBox !== null && leaveBox.checked;
    sum();
  };

  if (leaveBox) leaveBox.addEventListener("change", syncLeave);
  syncLeave();
}

// The same guard the wizard module carries, for the same reason: if the pack
// is ever split and this arrives in an async chunk, DOMContentLoaded is long
// gone and only the readyState branch still calls setup().
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
